import { render, staticRenderFns } from "./IndividualReview.vue?vue&type=template&id=53e60b51"
import script from "./IndividualReview.vue?vue&type=script&lang=js"
export * from "./IndividualReview.vue?vue&type=script&lang=js"
import style0 from "./IndividualReview.vue?vue&type=style&index=0&id=53e60b51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports